var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload28X28(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.795 5.09c.22 0 .392.1.481.264.045.081.07.179.07.289V16.11l2.52-2.52a.53.53 0 0 1 .767 0 .53.53 0 0 1 0 .767l-3.454 3.455a.554.554 0 0 1-.188.13l.001.004a.521.521 0 0 1-.195.034c-.045 0-.127 0-.185-.03a.546.546 0 0 1-.198-.135l-.006-.005a.613.613 0 0 1-.026-.026L9.96 14.362a.53.53 0 0 1 0-.768.53.53 0 0 1 .768 0l2.52 2.52V5.639c0-.329.219-.548.548-.548ZM7.327 22.753h12.994c1.919 0 3.509-1.262 3.509-2.797v-5.922c0-.33-.22-.549-.548-.549-.33 0-.549.22-.549.549v5.922c0 .987-1.041 1.755-2.412 1.755H7.327c-1.316 0-2.412-.768-2.412-1.755v-5.922c0-.33-.22-.549-.548-.549-.33 0-.549.22-.549.549V19.9c0 1.59 1.536 2.852 3.51 2.852Z",
    fill: "#0B0204"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload28X28);
export default __webpack_public_path__ + "static/media/download-28x28.227fe8173902322195429f99f3e34fb9.svg";
export { ForwardRef as ReactComponent };